import { Dispatch, SetStateAction, useState } from 'react';
import { USDT, formatUSD } from '../../../helpers/helperFunctions';
import { CaptionText, H2, P1 } from '../../../styles/FontStyles';
import {
  Button,
  Flexed,
  SectionSeparator
} from '../../../styles/GlobalComponents';
import { lightTheme } from '../../../styles/GlobalStyles';
import { Label } from '../../../styles/stylesStyled';

import { useTranslation } from 'react-i18next';
import { Hub } from '../../../components/common/Hub/Hub';

import { CheckText } from '../../../components/common/CheckText';
import { InputBackOffice } from '../../../components/common/InputBackoffice';

import { useAppSelector } from '../../../app/hooks';
import lpIcon from '../../../assets/icons/backOffice/LP.svg';
import usdtIcon from '../../../assets/icons/backOffice/USDT.svg';
import { PurchaseSteps } from '../Maeketplace.types';
import { ErrorToast } from '../../../components';

interface PayMixedProps {
  selectedPackage: any;
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedLicence: any;
  lp: string;
  club: string;
  usdt: string;
  cash: string;
  calculatedPrice: string;
  setLp: Dispatch<SetStateAction<string>>;
  setClub: Dispatch<SetStateAction<string>>;
  setCalculatedPrice: Dispatch<SetStateAction<string>>;
  setCash: Dispatch<SetStateAction<string>>;
  handlePay: (step: PurchaseSteps) => void;
  userDiscountCodeId?: number | null;
}

export const PayMixed = ({
  selectedPackage,
  setStep,
  selectedLicence,
  lp,
  club,
  cash,
  calculatedPrice,
  setLp,
  setClub,
  setCalculatedPrice,
  setCash,
  handlePay,
  userDiscountCodeId
}: PayMixedProps) => {
  const { t } = useTranslation('marketplace');

  const { loyaltyPoints, availableRewardPoints, shoppingPoints } =
    useAppSelector((state) => state.auth.userInfo.user.userTickets);

  const [checkbox, setCheckbox] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);

  const {
    packageId,
    image,
    name,
    price,
    weeklyCap,
    limitedQuantity,
    calculator,
    tradingBinaryPercentage,
    willyMemeCoins,
    subtitle,
    tickets,
    subscriptionPrice
    // eslint-disable-next-line no-unsafe-optional-chaining
  } = selectedPackage;

  const amountToPay = selectedLicence
    ? subscriptionPrice
      ? selectedLicence.price + price + subscriptionPrice
      : selectedLicence.price + price
    : subscriptionPrice
    ? subscriptionPrice + price
    : price;

  const amount = Number(lp) + Number(club) + Number(cash);

  const tether = amountToPay - amount;

  const handlePayFull = (event: any) => {
    event.currentTarget.disabled = true;
    handlePay(PurchaseSteps.SUCCESS);
  };

  const handlePayPartially = () => {
    setCalculatedPrice(tether.toString());
    setStep(PurchaseSteps.PAY_TETHER);
  };

  const handleBalanceValidation = (pay: () => void) => {
    if (Number(lp) > loyaltyPoints) {
      ErrorToast(`You don't have enough LP to buy a package.`);
    }
    if (Number(club) > shoppingPoints) {
      ErrorToast(`You don't have enough Club balance to buy a package.`);
    }
    if (Number(cash) > availableRewardPoints) {
      ErrorToast(`You don't have enough Cash balance to buy a package.`);
    }
    if (
      Number(lp) > loyaltyPoints ||
      Number(club) > shoppingPoints ||
      Number(cash) > availableRewardPoints
    )
      return;

    pay();
  };

  const showButtonText = () => {
    if (selectedLicence === null && packageId >= 170) {
      return 'Pay with USDT and CLUB balance';
    }
    if (selectedLicence === null && packageId >= 150) {
      return 'Pay with USDT, CLUB and LP balance';
    } else {
      return 'Pay with USDT and CLUB balance';
    }
  };

  const showLoyaltyPoints = () => {
    if (packageId >= 170) {
      return <></>;
    }
    if (selectedLicence === null && packageId >= 150) {
      return (
        <>
          <Label style={{ width: '100%' }}>Loyalty Points</Label>
          <InputBackOffice
            placeholder={'Type in amount to transfer'}
            icon={lpIcon}
            style={{ marginBottom: 8 }}
            onChange={(e: any) => {
              setLp(e.replace(/[.,\s\D]/g, ''));
            }}
            pattern='[0-9]'
            value={lp.replace(/[.,\s\D]/g, '')}
            type='number'
          />
          <CaptionText mb='20' color={lightTheme.colors.neutral500}>
            Current LP balance: {formatUSD(loyaltyPoints)} LP
          </CaptionText>
        </>
      );
    }
  };

  return (
    <div>
      <P1 bold mb='20'>
        {t('selected_staking_hub_nft')}:
      </P1>

      <Hub
        key={packageId}
        condensed
        image={image}
        title={name}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        price={subscriptionPrice ? price : amountToPay}
        subscriptionPrice={subscriptionPrice}
        selectedLicence={selectedLicence}
        packagePrice={price}
        includesSubscription={selectedLicence?.access}
        isDiscount={userDiscountCodeId !== null}
        willyMemeCoins={willyMemeCoins}
        subtitle={subtitle}
        tickets={tickets}
        showTickets={packageId >= 170 && packageId < 180}
        info={
          <>
            {calculator && (
              <Flexed alignEnd end>
                <H2 bold mr='16' alignEnd>
                  {calculator}
                </H2>
                <CaptionText bold right mb='4'>
                  {t('reward')}
                  <br /> {t('multiplicator')}
                </CaptionText>
              </Flexed>
            )}
          </>
        }
      />

      {showLoyaltyPoints()}

      <Label style={{ width: '100%' }}>Club Balance</Label>
      <InputBackOffice
        placeholder={'Type in amount to transfer'}
        icon={usdtIcon}
        style={{ marginBottom: 8 }}
        onChange={(e: any) => {
          setClub(e.replace(/[.,\s\D]/g, ''));
        }}
        pattern='[0-9]'
        value={club.replace(/[.,\s\D]/g, '')}
        type='number'
      />
      <CaptionText mb='20' color={lightTheme.colors.neutral500}>
        Current Club balance: {formatUSD(shoppingPoints)} Club USDT
      </CaptionText>

      <Label style={{ width: '100%' }}>USDT Balance</Label>
      <InputBackOffice
        placeholder={'Type in amount to transfer'}
        icon={usdtIcon}
        style={{ marginBottom: 8 }}
        onChange={(e: any) => {
          setCash(e.replace(/[.,\s\D]/g, ''));
        }}
        pattern='[0-9]'
        value={cash.replace(/[.,\s\D]/g, '')}
        type='number'
      />

      <CaptionText mb='20' color={lightTheme.colors.neutral500}>
        Current USDT balance: {formatUSD(availableRewardPoints)} USDT
      </CaptionText>

      <SectionSeparator />

      <P1 mb='8' semiBold>
        Payment Sum: {formatUSD(amount)} / {formatUSD(amountToPay)} {USDT}
      </P1>

      <CaptionText semiBold mb='20' color={lightTheme.colors.primary900}>
        Important: If you don’t have enough{' '}
        {!selectedLicence && packageId < 170 ? 'Loyalty Points,' : ''} Club
        Balance & USDT Balance or if you prefer not to use the full amount you
        can pay the remaining balance with USDT (Tether).
        <br />
        <br />
        In this case, the package will only become visible after the full
        payment is completed.
        <br />
        <br />
        If you don’t complete the payment,
        {packageId < 170 && ' your Loyalty Points,'} Club Balance, and/or USDT
        Balance will be non-refundable.
      </CaptionText>

      <CheckText
        checked={checkbox}
        onClick={() => setCheckbox(!checkbox)}
        text={`I confirm that I’ve selected the exact ${
          !selectedLicence && packageId < 170 ? 'Loyalty Points,' : ''
        }  Club balance, and USDT balance that I wish to use for this purchase.`}
      />

      <CheckText
        checked={checkbox2}
        onClick={() => setCheckbox2(!checkbox2)}
        text={`I understand that NO PO, NO PV will be calculated and NO Bonuses will be paid out for the amount purchased with Loyalty Points.`}
      />

      <Button
        mt='20'
        mb='20'
        disabled={!(checkbox && checkbox2 && amount === amountToPay)}
        onClick={(e: any) => handleBalanceValidation(() => handlePayFull(e))}>
        {showButtonText()}
      </Button>
      <Button
        disabled={!(checkbox && checkbox2 && amount < amountToPay)}
        onClick={() => handleBalanceValidation(handlePayPartially)}>
        Make partial payment with selected balances and cover the rest with USDT
        (Tether)
      </Button>
    </div>
  );
};
